import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal, Button } from 'react-bootstrap';
import RndModal from '../../../components/modals/RndModal';
import moment from 'moment';

const FolderInfoSection = styled.div`
  padding: 15px;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;

  h4 {
    margin: 0 0 10px 0;
    color: #495057;
    font-size: 16px;
    font-weight: 600;
  }

  .folder-details {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px 16px;
    font-size: 14px;
    align-items: baseline;
    justify-items: baseline;

    .label {
      font-weight: 600;
      color: #6c757d;
    }

    .value {
      color: #495057;
      word-break: break-all;
    }
  }
`;

const ReasonSection = styled.div`
  flex: 1;
  padding: 15px;

  h4 {
    margin: 0 0 10px 0;
    color: #495057;
    font-size: 16px;
    font-weight: 600;
  }

  .reason-input {
    width: 100%;
    min-height: 120px;
    padding: 10px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;

    &:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }

    &::placeholder {
      color: #6c757d;
    }
  }

  .char-count {
    margin-top: 5px;
    font-size: 12px;
    color: #6c757d;
    text-align: right;
  }
`;

const ModalFooterStyled = styled(Modal.Footer)`
  .status-text {
    display: flex;
    align-items: center;
    margin-right: auto;
    color: red;
    font-size: 14px;
  }
`;

class IgnoreDirConfirmModal extends Component {
  state = {
    reason: ''
  };

  handleReasonChange = (event) => {
    this.setState({ reason: event.target.value });
  };

  handleSubmit = () => {
    const { reason } = this.state;
    const { folder, onSubmit } = this.props;

    if (reason.trim() && folder) {
      onSubmit(folder, reason.trim());
      this.setState({ reason: '' }); // Reset reason after submit
    }
  };

  handleCancel = () => {
    this.setState({ reason: '' });
    this.props.onClose();
  };

  renderFolderInfo = () => {
    const { folder } = this.props;
    
    return (
      <FolderInfoSection>
        <h4>Directory Information</h4>
        <div className="folder-details">
          <span className="label">Name:</span>
          <span className="value">{(folder && (folder.name || folder.FileName)) || 'Unknown'}</span>

          <span className="label">Full Path:</span>
          <span className="value">{(folder && (folder.fullPath || folder.FullPath)) || 'Unknown'}</span>

          <span className="label">Size:</span>
          <span className="value">{(folder && (folder.formattedSize || folder.size)) || 'Unknown'}</span>

          <span className="label">Modified:</span>
          <span className="value">{(folder && (moment(folder.modifiedOn).format('MM/DD/YYYY hh:mm:ss A'))) || 'Unknown'}</span>
        </div>
      </FolderInfoSection>
    );
  };

  renderReasonSection = () => {
    const { reason } = this.state;
    const maxLength = 1000;

    return (
      <ReasonSection>
        <h4>Reason for ignore:</h4>
        <textarea
          className="reason-input"
          placeholder="Please provide a reason for ignoring this directory, for example: 'The download was cancelled after data was partially downloaded' or 'This data was sent by us with cc: to ourselves'"
          value={reason}
          onChange={this.handleReasonChange}
          maxLength={maxLength}
        />
        <div className="char-count">
          {reason.length}/{maxLength} characters
        </div>
      </ReasonSection>
    );
  };

  render() {
    const { isVisible } = this.props;
    const { reason } = this.state;

    if (!isVisible) {
      return null;
    }

    return (
      <RndModal
        show={true}
        onHide={this.handleCancel}
        backdrop="static"
        enforceFocus={false}
        bsSize="large"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Ignore Directory
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflow: 'unset', padding: '0' }}>
          <div className="container-fluid" style={{ padding: '0' }}>
            {this.renderFolderInfo()}
            {this.renderReasonSection()}
          </div>
        </Modal.Body>
        <ModalFooterStyled>
          <div className="status-text">
            'WARNING: If you click "Confirm Ignore", the directory will be DELETED!'
          </div>
          <Button bsStyle="default" onClick={this.handleCancel}>
            Cancel
          </Button>
          <Button
            bsStyle="danger"
            onClick={this.handleSubmit}
            disabled={!reason.trim() || reason.length < 10}
          >
            Confirm Ignore
          </Button>
        </ModalFooterStyled>
      </RndModal>
    );
  }
}

IgnoreDirConfirmModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  folder: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

IgnoreDirConfirmModal.defaultProps = {
  folder: null
};

export default IgnoreDirConfirmModal; 